import { render, staticRenderFns } from "./PayOnWebPromoPopup.vue?vue&type=template&id=eea3f948"
import script from "./PayOnWebPromoPopup.vue?vue&type=script&lang=js"
export * from "./PayOnWebPromoPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports